import {useState, useEffect, useRef, Fragment, useCallback} from 'react';
import * as U from './util';
import {emitEvent, useEventHandler, Event} from './events';
import {BUTTON_STYLE_CONSOLE} from './styles';

type ConsoleProps = {
  logs: string[];
};

export function Console({logs}: ConsoleProps) {
  const [lastLog, setLastLog] = useState(0);
  const [isHidden, setIsHidden] = useState(false);
  const [lastMessage, setLastMessage] = useState<string | null>(null);
  const [isScrollingEnabled] = useState(true);
  const [isStamping, setStamping] = useState(true);
  const bottom = useRef<HTMLDivElement>(null);
  const handleHide = useCallback(() => {
    setIsHidden(isHidden => !isHidden);
  }, []);
  // Disabled toggling of scroll because its not really useful ATM
  // const handleScrolling = useCallback(() => {
  //   setIsScrollingEnabled(isScrollingEnabled => !isScrollingEnabled);
  // }, []);
  const handleCopy = useCallback(() => {
    const text = logs.join('\n');
    navigator.clipboard.writeText(text);
    setLastMessage('Copied to clipboard');
  }, [logs]);
  const handleClear = useCallback(() => {
    U.clearLogs();
    U.appLog(`Log cleared at ${new Date().toLocaleTimeString()}`);
  }, []);
  const handlePasteSAT = useCallback(() => {
    emitEvent(Event.USER_MOBILE_PASTE, null);
  }, []);
  useEventHandler(Event.LOG, () => {
    setLastLog(lastLog => lastLog + 1);
  });
  const handleToggleStamping = useCallback(() => {
    U.setStamps(!isStamping);
    setStamping(isStamping => !isStamping);
  }, []);
  // Disabled toggling of scroll because its not really useful ATM
  // useEffect(() => {
  //   setLastMessage(isScrollingEnabled ? 'Scrolling is enabled' : 'Scrolling is disabled');
  // }, [isScrollingEnabled]);

  // Whenever the list of logs changes, if scrolling is not disabled, force scroll to the bottom element
  useEffect(() => {
    if (isScrollingEnabled) bottom.current?.scrollIntoView({behavior: 'smooth'});
  }, [lastLog]);

  return (
    <div className="w-screen flex flex-col relative">
      <div className="w-screen flex flex-col absolute bottom-12 pointer-events-none">
        <h1 className=" text-center sm:text-3xl font-extrabold text-white opacity-20">
          PASTE SAT OR PAK ANYWHERE INTO THE PAGE
        </h1>
        <h1 className=" text-center sm:text-2xl font-extrabold text-white opacity-20">
          OR SET IN URL VIA ?SAT=YOUR_SAT_HERE OR ?PAK=YOUR_PAK_HERE
        </h1>
        <h1 className=" text-center sm:text-2xl font-extrabold text-white opacity-20">
          CHANGE PROVISIONING VIA ?PRV=PROVISIONING.DOMAIN.NAME.HERE
        </h1>
      </div>
      <div className="flex flex-row h-10 border-t-2 border-b-2 border-gray-700 items-center bg-gray-400 gap-1">
        <button className={`${BUTTON_STYLE_CONSOLE} ml-2`} onClick={handleHide}>
          {isHidden ? 'Show' : 'Hide'}
        </button>
        <button className={BUTTON_STYLE_CONSOLE} onClick={handleToggleStamping}>
          {isStamping ? '-' : '1'}
        </button>
        <button className={BUTTON_STYLE_CONSOLE} onClick={handleCopy}>
          Copy
        </button>
        <button className={BUTTON_STYLE_CONSOLE} onClick={handleClear}>
          Clear
        </button>
        {U.isMobileBrowser() && (
          <button className={BUTTON_STYLE_CONSOLE} onClick={handlePasteSAT}>
            Paste SAT
          </button>
        )}
        <span className="h-7 mx-1 pl-1 border-l-2 border-gray-700" />
        <span className="text-gray-900 text-sm ">{lastMessage}</span>
      </div>
      <pre
        className={`w-screen h-[300px] bg-black text-green-500 text-sm overflow-y-scroll overflow-x-hidden ${isHidden && 'hidden'}`}
      >
        {logs.map((msg, i) => (
          <Fragment key={`${i}`}>
            {msg}
            <br />
          </Fragment>
        ))}
        <div ref={bottom} />
      </pre>
    </div>
  );
}
